export default __webpack_public_path__ + "cec7d7ba250ca964e427ba27f9b8ffa1.png";